export const contentProps = {
    id: { type: String },
    title: { type: String },
    titleTag: { type: String, default: 'h2' },
    lead: { type: String },
    bodyText: { type: String },
};
